import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, FavExList } from '../components';

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const FavExchanges = ({ theme, exchanges, selectExchange }) => (
  <Screen theme={theme} title="Favorites">
    <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <FavExList exchanges={exchanges} selectExchange={selectExchange} />
    </Content>
    <BottomTabBar selected="favorites" />
  </Screen>
);

export default withTheme(FavExchanges);



// WEBPACK FOOTER //
// ./src/containers/FavExchanges.js